import React from 'react';
import { Lightbulb, Palette, Code, Rocket } from 'lucide-react';
export const ProcessSection = () => {
  const processes = [{
    title: 'Idea Refinement',
    description: 'We transform your one-sentence concept into a detailed app vision through collaborative exploration and market analysis.',
    icon: <Lightbulb className="w-8 h-8 text-[#00E5FF]" data-id="element-140" />,
    glowColor: 'from-[#00E5FF]'
  }, {
    title: 'Experience Design',
    description: 'Our designers craft intuitive, engaging user experiences that capture your vision with futuristic aesthetics.',
    icon: <Palette className="w-8 h-8 text-[#B721FF]" data-id="element-141" />,
    glowColor: 'from-[#B721FF]'
  }, {
    title: 'Development',
    description: 'Expert engineers build your app with cutting-edge technology, ensuring performance, security, and scalability.',
    icon: <Code className="w-8 h-8 text-[#00E5FF]" data-id="element-142" />,
    glowColor: 'from-[#00E5FF]'
  }, {
    title: 'Launch & Growth',
    description: 'We deploy your app and implement growth strategies to build your user base and establish market presence.',
    icon: <Rocket className="w-8 h-8 text-[#B721FF]" data-id="element-143" />,
    glowColor: 'from-[#B721FF]'
  }];
  return <section id="process" className="relative py-20 w-full overflow-hidden" data-id="element-144">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[#0B0C10] z-0" data-id="element-145">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1534972195531-d756b9bfa9f2?q=80&w=3270&auto=format&fit=crop')] opacity-5 bg-cover bg-center" data-id="element-146"></div>
        <div className="absolute inset-0 grid grid-cols-12 gap-4 opacity-10" data-id="element-147">
          {Array.from({
          length: 12 * 12
        }).map((_, i) => <div key={i} className="border-[0.5px] border-[#F5F5F5]/5" data-id="element-148"></div>)}
        </div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold font-['Orbitron'] mb-4" data-id="element-151">
            Our{' '}
            <span className="bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-152">
              Process
            </span>
          </h2>
          <p className="text-lg text-[#F5F5F5]/70 max-w-2xl mx-auto" data-id="element-153">
            From initial concept to market success, our seamless development
            journey transforms ideas into reality.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-154">
          {processes.map((process, index) => <div key={index} className="relative bg-[#0B0C10]/80 backdrop-blur-sm border border-[#F5F5F5]/10 rounded-xl p-6 transition-all duration-300 hover:border-[#00E5FF]/50 group" data-id="element-155">
              <div className={`absolute -inset-0.5 bg-gradient-to-r ${process.glowColor} to-transparent opacity-0 group-hover:opacity-20 rounded-xl blur-sm transition-opacity duration-300`} data-id="element-156"></div>
              <div className="relative" data-id="element-157">
                <div className="mb-5 rounded-full w-16 h-16 flex items-center justify-center bg-[#F5F5F5]/5 border border-[#F5F5F5]/10" data-id="element-158">
                  {process.icon}
                </div>
                <h3 className="text-xl font-bold font-['Orbitron'] mb-3" data-id="element-159">
                  {process.title}
                </h3>
                <p className="text-[#F5F5F5]/70" data-id="element-160">{process.description}</p>
                <div className="absolute top-0 right-0 w-8 h-8 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#B721FF] flex items-center justify-center text-[#0B0C10] font-bold" data-id="element-161">
                  {index + 1}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};